import moment from "moment";
class license {
    constructor(
        procId,
        nombre,
        estado,
        operId,
        fechaI,
        fechaU,
        operNombre){
        this.procId = procId;
        this.name = nombre;
        this.statusIcon = this.getStatusDescription(estado);    
        this.status = estado;
        this.operId = operId;
        this.fechaI = moment(fechaI).format('YYYY-MM-DD HH:mm');
        this.fechaU = moment(fechaU).format('YYYY-MM-DD HH:mm');
        this.operName = operNombre
    }
    getStatusDescription(estado) {
        if (estado === "I") {
            return "⌛";
        } else if (estado === "T") {
            return "✔️";
        } else {
            return "mdi-checkbox-multiple-marked-outline";
        }
    }
    static fromJson({
        procId,
        nombre,
        estado,
        operId,
        fechaI,
        fechaU,
        operNombre
    }) {
        return new license(
            procId,
            nombre,
            estado,
            operId,
            fechaI,
            fechaU,
            operNombre
        );
    }
}
export default license;
